import { render, staticRenderFns } from "./add_new2.vue?vue&type=template&id=2fb885c0&scoped=true"
import script from "./add_new2.vue?vue&type=script&lang=js"
export * from "./add_new2.vue?vue&type=script&lang=js"
import style0 from "./add_new2.vue?vue&type=style&index=0&id=2fb885c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb885c0",
  null
  
)

export default component.exports